const initModule = (module) => {
    const snippets = module.querySelectorAll('.m-advantages__snippets .m-advantages__snippet');
    const items = module.querySelectorAll('.m-advantages__item');
    items.forEach((item) => {
        const headline = item.querySelector('.m-advantages__headline');
        if (!headline) {
            return;
        }
        headline.addEventListener('click', () => {
            items.forEach((currentItem) => currentItem.classList.toggle('active', currentItem === item));
            snippets.forEach((snippet) => snippet.classList.toggle('active', snippet.dataset.id === item.dataset.id));
        });
    });
};
export const initAdvantages = () => {
    const modules = document.querySelectorAll('.m-advantages');
    modules.forEach((module) => initModule(module));
};
